export default __webpack_public_path__ + "static/media/lock.9a41f1d5.jpeg";